import type { GroupComparison } from '../../api/groupsApi';
import MetricValue from '../Analytics/components/MetricValue';

export default function GroupInitiativeComparison({ comparison }: { comparison: GroupComparison[] }) {
  if (!comparison.length) return <p className="mt-3 text-sm">No measures selected.</p>;
  return <div className="mt-3 space-y-3" aria-label="Initiative comparison measures">
    {comparison.map(row => <div key={row.measure} aria-label={`${row.measure} comparison`} className="flex flex-wrap justify-between gap-2 border-t border-pd-rule pt-3 text-sm">
      <span>{row.measure}</span>
      <span><MetricValue metric={row.start} /> → <MetricValue metric={row.end} /> <strong className="ml-1">Change: {row.change === null ? 'Not available' : <MetricValue metric={{ value: row.change, status: 'ready', unit: row.end.unit === '%' ? 'pp' : row.end.unit }} />}</strong></span>
    </div>)}
  </div>;
}
